import React, {PropTypes} from 'react';
import { PageHeader, FormGroup, ControlLabel, Button, Modal, HelpBlock } from 'react-bootstrap';
import { Row, Col } from 'antd';
import Classnames from 'classnames';
import axios from 'axios'
import normalizePhone from '../core/normalizePhone'
import "./TextAppLink.css"

// SHARED
import { FieldGroup } from '../core/components/FieldGroup';


export default class TextAppLink extends React.Component {

  constructor(props){
    super(props)

    this.state = this.initialState();

    this.axiosClient = axios.create();
  }

  initialState(){
    return {
      phone: "",
      submitting: false,
      success: false,
      error: false,
      error_message: '',
      valid: true, //initially for the button look
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    let state = this.state
    state["submitting"] = true;
    state["disabled"] = true;

    this.setState(state);

    // let url = process.env.REACT_APP_API_BASE_URL + 'text_messages'
    let url = "https://api.everlance.com/text_messages"
    // Set number and remove all non digits
    const digits = this.state.phone.match(/\d+/g)
    if (!digits) {
      state["error"] = true;
      state["error_message"] = "Please enter a valid number.";
      state["submitting"] = false;
      state["valid"] = false;
      this.setState(state)
      return
    }
    let data = { number: digits.join("") }

    // Check coupon with server
    this.axiosClient.post(url, data).then(response => {
      let state = this.state

      if (response.status != 201) {
        // Error
        console.log(response.data.error_message);
        state["error"] = true;
        state["error_message"] = "Oops something went wrong. Please download the app through the App Store.";
        state["submitting"] = false;
        state.phone = ""
        this.setState(state)

      } else {
        // Success
        console.log(response.data);
        state["success"] = true;
        state["error_message"] = "";
        state["submitting"] = false;
        state.phone = ""
        state["phone"] = "";
        this.setState(state)
        // wait 1 second and callback
        this.props.onSubmit && setTimeout(()=> this.props.onSubmit(), 1000)
      }
    }).catch( err => {
      let state = this.state

      // Error
      console.log(err);
      state["error"] = true;
      state["error_message"] = "Oops something went wrong. Please download the app through the App Store.";
      state["submitting"] = false;
      state.phone = ""
      this.setState(state)
    })

  }

  handleChange(e) {
    let state = this.state
    state[e.target.name] = normalizePhone(e.target.value)
    this.setState({
      ...state,
      valid: e.target.value.length>11
    })
  }

  render() {

    var buttonContent;
    if (this.state.success) {
      buttonContent = "Sent!"
    } else {
      buttonContent = this.state.submitting ? "Sending..." : (this.props.buttonText||"Get the app")
    }

    var errorMessage;
    if (this.state.error) {
      errorMessage = this.state.error_message;
    } else {
      errorMessage = null;
    }

    const submitBtnClass = Classnames({
      "submitting": this.state.submitting,
      // "btn-main-blue": !this.state.success,
      "btn-main-green": true //this.state.success
    })

    const errorsBox = {
        width: "100% ",
        textAlign: "center",
        color: "#d02f2f",
        marginTop: "15px"
    }
    const btnInlineStyle =   {
        width: "100%",
        height: "45px",
        fontSize: "18px"
    }

    return (
      <Row className="text-app-link" type="flex" justify="center" align="middle">
        {/*<Col xs={24} sm={12}>*/}
          <form onSubmit={ this.handleSubmit.bind(this) }>
                <FieldGroup
                  id="phone-text-app-link"
                  type="text"
                  label={this.props.label||"Enter your phone number, we'll text you a link."}
                  placeholder="123-456-7890"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.handleChange.bind(this)}
                />
                <Button disabled={!this.state.valid || this.state.submitting} className={submitBtnClass} style={btnInlineStyle} type="submit">
                  {buttonContent}
                </Button>
                <div style={errorsBox}>
                  {errorMessage}
                </div>
          </form>
        {/*</Col>
        <Col xs={24} sm={12}>
          <Row className="app-store-buttons" type="flex" justify="center" align="middle">
            <Col style={{textAlign: "center"}} xs={12} sm={24}>
              <img target="_blank" href="https://bnc.lt/E9ac/f8FS4VM8bw" className="app-store-button" src="https://s3.amazonaws.com/cdn.everlance.com/images/dashboard/app-store-button.png" />
            </Col>
            <Col style={{textAlign: "center"}} xs={12} sm={24}>
              <img  target="_blank" href="https://play.google.com/store/apps/details?id=com.everlance&hl=en" className="google-play-button" src="https://s3.amazonaws.com/cdn.everlance.com/images/dashboard/google-play-button.png" />
            </Col>
          </Row>
        </Col>*/}
      </Row>
    );
  }
}

TextAppLink.propTypes = {
};



// WEBPACK FOOTER //
// ./src/home/TextAppLink.js